import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false, coordinadorOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#0A0A0A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#495057] font-['IBM_Plex_Sans']">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const getHomePath = () => {
    if (user.role === 'admin') return '/admin';
    if (user.role === 'coordinador') return '/coordinador';
    return '/dashboard';
  };

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to={getHomePath()} replace />;
  }

  if (coordinadorOnly && user.role !== 'coordinador') {
    return <Navigate to={getHomePath()} replace />;
  }

  return children;
};
